<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap" v-if="!categorya_ids">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="全分类名称">
          <el-input placeholder="请输入全分类名称" v-model="formInline.search">
           
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select size="small" v-model="formInline.code" placeholder="所有code">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(item, index) in codeList" :key="index" :label="item.code" :value="item.code"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail"  v-if="!categorya_ids">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加全分类</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="code" label="code"></el-table-column>
            <!-- <el-table-column prop="parent_name" label="上一级分类名称"></el-table-column> -->
            <el-table-column prop="name" label="全分类名称"></el-table-column>
            <el-table-column prop="image_id" label="分类图片">
                <template slot-scope="scope">
                  <img
                    v-img-url="scope.row.images?scope.row.images.file_path:''"
                    width="50"
                    height="50"
                  />
                </template>
            </el-table-column>   
         
  
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :categorya_id="categorya_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import CategoryaApi from '@/api/categorya.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    props: ['categorya_ids'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          code:""
        },

        open_add:false,
        open_edit:false,
        categorya_id:"",
        codeList:[]
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.categorya_ids = self.categorya_ids;
        self.loading = true;
        CategoryaApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.codeList = data.data.codeList
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.categorya_id = row.categorya_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('请确保该分类下没有关联任何数据，此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            CategoryaApi.del(
              {
                categorya_id: row.categorya_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/categorya/index.vue